import type { ReactNode } from "react";
import "./TopRow.scss";
import TemplatesTagsAndPositionsTabs from "@/pages/human-resources/time-management/components/schedule-palette/top-row/tabs/TemplatesTagsAndPositionsTabs.tsx";
import ControlledSearchBar from "@/shared/components/generic/search/ControlledSearchBar.tsx";
import { Size } from "@/shared/components/generic/UiEnums.ts";
import classNames from "classnames";
import OrientationButton from "@/pages/human-resources/time-management/components/schedule-palette/top-row/orientation-button/OrientationButton.tsx";
import type { SchedulePaletteView } from "@/pages/human-resources/time-management/model/schedule-view/palette/SchedulePaletteView.ts";
import useScheduleViewState from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewState.ts";

interface Properties {
  onViewTypeChange: (vt: SchedulePaletteView) => void;
  horizontal: boolean;
  onToggleHorizontal: () => void;
  searchInput: string;
  onSearchInputChanged: (s: string) => void;
}

export default function TopRow(props: Properties): ReactNode {
  const {
    palette: { view: viewType },
  } = useScheduleViewState();
  return (
    <div className={classNames("top-row", props.horizontal && "horizontal")}>
      <TemplatesTagsAndPositionsTabs
        viewType={viewType}
        onTabChange={props.onViewTypeChange}
        horizontal={props.horizontal}
      />

      {props.horizontal && (
        <div className="search-bar-wrapper">
          <ControlledSearchBar
            size={Size.SMALL}
            width={"250px"}
            input={props.searchInput}
            onInputChanged={props.onSearchInputChanged}
            searchOnKeyStroke={true}
            onSearch={props.onSearchInputChanged}
          />
        </div>
      )}
      <OrientationButton
        horizontal={props.horizontal}
        onToggleHorizontal={props.onToggleHorizontal}
      />
    </div>
  );
}
